/**
 * The listing's external post records (Facebook Marketplace / Craigslist), as one shared query: the
 * listing page shell (header chip, Pause / Close confirmations, take-down notice), the Marketing tab
 * and a lead's detail page read the same cache entry, which the `external_listing_post.changed`
 * event and the record / remove mutations invalidate.
 */
import { useQuery } from '@tanstack/react-query';
import { externalPostsKey, listExternalPosts } from '../lib/external-listing-posts.api';

export function useListingExternalPosts(listingId: string | null | undefined) {
  return useQuery({
    queryKey: externalPostsKey(listingId ?? ''),
    queryFn: () => listExternalPosts(listingId!),
    enabled: !!listingId,
  });
}
